<template>
  <!--审批步骤start-->
  <div class="detail-step">
    <div class="detail-step-vertical">
      <div class="detail-steps-items">
        <div
          class="detail-items"
          v-for="(item, index) in developmentHistory"
          :key="index"
        >
          <div>
            <!-- <section class="items-title">
              <h1>{{ item.time }}</h1>
            </section> -->
            <section class="items-desc">
              <div class="items-row">
                <div class="items-col name">{{ item.time }}</div>
                <!-- <div class="items-col time">2020.06.19 16:05</div> -->
              </div>
              <div class="items-content">{{ item.message }}</div>
            </section>
          </div>
          <div class="items-container">
            <img src="@/assets/images/circle.png" alt="" />
          </div>
          <div class="items-step-line"></div>
        </div>
      </div>
    </div>
  </div>
  <!--审批步骤end-->
</template>
<script>
import { about } from "@/assets/js/data.js";
export default {
  data() {
    return {
      developmentHistory: about.developmentHistory,
    };
  },
};
</script>
<style lang="scss" scoped>
.detail-step {
  .detail-step-vertical {
    padding-left: 40px;
    padding-top: 2rem;
    // overflow: hidden;
    .detail-steps-items {
      .detail-items {
        position: relative;
        display: block;
        float: none;
        height: 8rem;
        padding: 10px 15px 10px 0;
        line-height: 0.48rem;
        &:last-child {
          .items-step-line {
            display: none;
          }
        }
        .items-container {
          position: absolute;
          top: 20px;
          left: -1.3rem;
          z-index: 2;
          line-height: 1;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          img {
            width: 1.7rem;
            height: 1.7rem;
          }
        }
        .items-step-line {
          top: 25%;
          left: -15px;
          width: 0.02667rem;
          height: 85%;
          position: absolute;
          background-color: #bbb;
          z-index: 1;
        }
        .items-title {
          font-size: 1.2rem;
          font-weight: 500;
          text-align: left;
          color: #333333;
          line-height: 19px;
          .items-tag {
            margin-left: 5px;
          }
        }
        .items-desc {
          padding: 13px 10px;
          box-sizing: border-box;
          margin-top: -2rem;
          width: 100%;
          background: #ffffff;
          border-radius: 5px;
          .items-row {
            display: flex;
            flex-direction: row;
            .items-col {
              width: 50%;
              height: 20px;
              line-height: 20px;
              &.name {
                display: flex;
                flex-direction: row;
                font-size: 1.2rem;
                font-weight: 500;
                text-align: left;
                color: #333333;
                line-height: 1.4rem;
                border-left: 2px solid #7cb7b3;
                padding-left: 1rem;
                height: 1.4rem;
                // .tag {
                //   font-size: 12px;
                //   margin-left: 10px;
                // }
              }
              &.time {
                font-size: 1rem;
                font-weight: 500;
                text-align: right;
                color: #999999;
                line-height: 19px;
              }
            }
          }
          .items-content {
            font-size: 1rem;
            font-weight: 500;
            text-align: left;
            color: #666666;
            line-height: 19px;
            margin-top: 1.1rem;
          }
        }
      }
    }
  }
}
</style>
